import { Component, EventEmitter, Input, Output, HostListener } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { Icons } from '../../../model/icon';
import { createPaginationArray } from '../../../functions/create-pagination-array';
import {Pagination} from '../../../model/pagination';

@Component({
  selector: 'app-pagination',
  imports: [
    NgForOf,
    NgIf,
    IconComponent
  ],
  templateUrl: './pagination.component.html',
  standalone: true,
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  @Input() pagination: Pagination<any> = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    first: true,
    last: true,
    size: 20,
    number: 0,
    numberOfElements: 0,
    empty: true,
    sort: { empty: true, unsorted: true, sorted: false },
    pageable: {
      offset: 0,
      sort: { empty: true, unsorted: true, sorted: false },
      unpaged: false,
      paged: true,
      pageNumber: 0,
      pageSize: 20
    }
  };

  @Output() emitPagination: EventEmitter<Pagination<any>> = new EventEmitter();

  sizes: number[] = [5, 10, 25, 50];

  isMobile: boolean = false;
  isVerySmallScreen: boolean = false;

  constructor() {
    this.checkScreenSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth <= 576;
    this.isVerySmallScreen = window.innerWidth <= 400;
  }

  getMaxPages(): number {
    if (this.isVerySmallScreen) return 3;
    if (this.isMobile) return 5;
    return 8;
  }

  selectPage(page: string) {
    const pageNumber = Number(page);
    if (!isNaN(pageNumber)) {
      this.pagination.number = pageNumber - 1;
      this.emitPagination.emit(this.pagination);
    }
  }

  selectSize(size: number) {
    this.pagination.size = size;
    this.pagination.number = 0;
    this.emitPagination.emit(this.pagination);
  }

  getPaginationArray(): (number | string)[] {
    return createPaginationArray(
      0,
      this.pagination.totalPages,
      this.pagination.number,
      this.getMaxPages()
    );
  }

  protected readonly Number = Number;
  protected readonly Icons = Icons;
}
